var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[69854]) {
		innerRemote = __webpack_require__(69854);
	}
	var gs = __webpack_require__.g || globalThis
	gs["transportation"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();